import { Button, Group } from '@ingeniorforeningen/figurine-core';
import { stripText } from '../../helpers/textsHelpers';

type Props = {
  onClick: () => void;
  variant: 'showHistory' | 'hideHistory';
  showHistoryText?: string;
  hideHistoryText?: string;
};

export const HistoryButton = ({ onClick, variant, showHistoryText, hideHistoryText }: Props) => {
  const text = variant === 'showHistory' ? stripText(showHistoryText) : stripText(hideHistoryText);
  const buttonIcon = variant === 'showHistory' ? 'ChevronDown' : 'ChevronUp';

  return (
    <Group justify="center" align="center" mt="xl" grow style={{ flex: 1 }}>
      <Button
        cypress="historyButton"
        icon={buttonIcon}
        text={text}
        variant="outline"
        onClick={onClick}
        fullWidth
      />
    </Group>
  );
};
